module.exports = __webpack_public_path__ + "media/images/icons/app_google_black-7d373e8635123182d26232a7afb0a170.png";